// extracted by mini-css-extract-plugin
export default {"container":"QpPJZ","title":"taQ_r","footer":"x6zzG","error":"FGFa8"};